var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoStgallerKantonalbank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo_stgaller_kantonalbank",
    "data-name": "logo stgaller kantonalbank",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 172.632,
    height: 35,
    viewBox: "0 0 172.632 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1809",
    "data-name": "Rectangle 1809",
    width: 172.632,
    height: 35,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_21700",
    "data-name": "Mask Group 21700",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15140",
    "data-name": "Path 15140",
    d: "M110.123,1.922a7.112,7.112,0,0,0-2.5-.42,3.346,3.346,0,0,0-3.657,3.588c0,3.89,4.588,2.963,4.588,5.2,0,1.059-1.065,1.515-1.859,1.515a4.625,4.625,0,0,1-2.368-.725l-.2,2.123a8.315,8.315,0,0,0,2.683.454c2.113,0,3.927-.976,3.927-3.554,0-3.941-4.587-3.081-4.587-5.12a1.521,1.521,0,0,1,1.65-1.633,4.9,4.9,0,0,1,2.128.506Z",
    transform: "translate(-57.327 -0.828)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15141",
    "data-name": "Path 15141",
    d: "M122.878,11.861c0,1.717.869,2.812,2.442,2.812a4.757,4.757,0,0,0,1.486-.2l-.06-1.784a1.643,1.643,0,0,1-.916.236c-.764,0-.944-.691-.944-1.431V7.448h1.783V5.8h-1.783V3.339l-2.009.725V5.8h-1.483v1.65h1.483Z",
    transform: "translate(-66.94 -1.841)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1803",
    "data-name": "Rectangle 1803",
    width: 2.098,
    height: 2.358,
    transform: "translate(61.253 10.273)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15142",
    "data-name": "Path 15142",
    d: "M154.241,1.99a9.29,9.29,0,0,0-3.072-.488c-3.552,0-5.742,2.255-5.742,6.282,0,3.974,2.355,5.877,5.742,5.877a11.876,11.876,0,0,0,3.386-.606V6.723h-4.227V8.574h2.22v3.066a5.1,5.1,0,0,1-1.379.168c-2.235,0-3.552-1.8-3.552-4.193,0-2.408,1.349-4.262,3.791-4.262a6.194,6.194,0,0,1,2.7.624Z",
    transform: "translate(-80.192 -0.828)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15143",
    "data-name": "Path 15143",
    d: "M170.409,10.965a3.773,3.773,0,0,1,2.382-.944c1.185,0,1.74.473,1.74,1.871h-1.11a5.519,5.519,0,0,0-2.592.5,2.594,2.594,0,0,0-1.319,2.476,2.572,2.572,0,0,0,2.7,2.577,2.7,2.7,0,0,0,2.382-1.5h.03a11.8,11.8,0,0,0,.09,1.3h1.77c-.045-.674-.074-1.28-.09-1.937-.015-.639-.03-1.3-.03-2.172V12.026c0-2.56-.975-3.655-3.328-3.655a6.26,6.26,0,0,0-2.683.658Zm1.019,3.773c0-1.33,1.334-1.5,2.234-1.5h.869a3.138,3.138,0,0,1-.42,1.784,1.647,1.647,0,0,1-1.409.776c-.72,0-1.274-.319-1.274-1.061",
    transform: "translate(-93.472 -4.616)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1804",
    "data-name": "Rectangle 1804",
    width: 2.009,
    height: 12.631,
    transform: "translate(85.055)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1805",
    "data-name": "Rectangle 1805",
    width: 2.009,
    height: 12.631,
    transform: "translate(89.368)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15144",
    "data-name": "Path 15144",
    d: "M209.552,12.059c.09-1.162.659-2.038,1.784-2.038s1.573.943,1.633,2.038Zm4.767,2.863a4.8,4.8,0,0,1-2.564.877,2.118,2.118,0,0,1-2.2-2.19h5.336c0-3.031-.811-5.238-3.673-5.238-2.4,0-3.582,2.072-3.582,4.582,0,2.846,1.483,4.5,4.032,4.5a4.847,4.847,0,0,0,2.653-.689V14.922",
    transform: "translate(-114.494 -4.616)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15145",
    "data-name": "Path 15145",
    d: "M227.738,17.247h2.008V14.064c0-1.244,0-3.535,1.633-3.535a1.866,1.866,0,0,1,.9.185V8.439a1.968,1.968,0,0,0-.615-.067c-1.2,0-2.024,1.364-2.113,2.173h-.032V8.574h-1.783Z",
    transform: "translate(-125.58 -4.617)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15146",
    "data-name": "Path 15146",
    d: "M105.393,59.48h2.612V52.69h.038l4.68,6.791h3.414l-5.578-7.734,5.353-6.9h-3.208l-4.7,6.288V44.851h-2.612Z",
    transform: "translate(-58.117 -24.732)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15147",
    "data-name": "Path 15147",
    d: "M133.124,56.068a4.692,4.692,0,0,1,2.965-1.173c1.474,0,2.164.587,2.164,2.326h-1.379a6.871,6.871,0,0,0-3.227.628,3.384,3.384,0,0,0,1.715,6.288,3.364,3.364,0,0,0,2.966-1.865h.037a14.8,14.8,0,0,0,.112,1.614h2.2c-.056-.839-.093-1.594-.112-2.411-.019-.8-.037-1.614-.037-2.7V57.389c0-3.186-1.213-4.548-4.141-4.548a7.81,7.81,0,0,0-3.339.817Zm1.269,4.7c0-1.657,1.659-1.867,2.778-1.867h1.082a3.923,3.923,0,0,1-.521,2.221,2.055,2.055,0,0,1-1.755.964c-.895,0-1.584-.4-1.584-1.319",
    transform: "translate(-72.79 -29.138)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15148",
    "data-name": "Path 15148",
    d: "M157.23,63.886h2.5V58.6c0-1.383.391-3.584,2.2-3.584,1.6,0,1.622,1.782,1.622,3.1v5.765h2.5V57.073c0-2.431-.989-4.232-3.265-4.232a3.466,3.466,0,0,0-3.152,1.717H159.6V53.091H157.23Z",
    transform: "translate(-86.701 -29.138)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15149",
    "data-name": "Path 15149",
    d: "M182.931,57.183c0,2.137,1.082,3.5,3.04,3.5a5.92,5.92,0,0,0,1.846-.25l-.073-2.222a2.037,2.037,0,0,1-1.137.293c-.952,0-1.176-.859-1.176-1.783v-5.03h2.22V49.638h-2.22V46.577l-2.5.9v2.16h-1.847v2.054h1.847Z",
    transform: "translate(-99.854 -25.684)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15150",
    "data-name": "Path 15150",
    d: "M198.908,58.563c0,3.1,1.846,5.576,5.017,5.576,3.192,0,5.038-2.474,5.038-5.576,0-3.563-2.182-5.722-5.038-5.722-2.835,0-5.017,2.158-5.017,5.722m2.612-.336c0-1.613.783-3.206,2.4-3.206,1.643,0,2.425,1.551,2.425,3.206,0,1.8-.5,3.732-2.425,3.732-1.9,0-2.4-1.949-2.4-3.732",
    transform: "translate(-109.683 -29.138)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15151",
    "data-name": "Path 15151",
    d: "M226.421,63.886h2.5V58.6c0-1.383.393-3.584,2.2-3.584,1.6,0,1.622,1.782,1.622,3.1v5.765h2.5V57.073c0-2.431-.989-4.232-3.265-4.232a3.466,3.466,0,0,0-3.152,1.717h-.037V53.091h-2.369Z",
    transform: "translate(-124.854 -29.138)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15152",
    "data-name": "Path 15152",
    d: "M252.309,56.068a4.691,4.691,0,0,1,2.965-1.173c1.474,0,2.164.587,2.164,2.326h-1.379a6.884,6.884,0,0,0-3.228.628,3.384,3.384,0,0,0,1.717,6.288,3.364,3.364,0,0,0,2.966-1.865h.037a14.792,14.792,0,0,0,.112,1.614h2.2c-.056-.839-.093-1.594-.112-2.411-.019-.8-.037-1.614-.037-2.7V57.389c0-3.186-1.213-4.548-4.141-4.548a7.808,7.808,0,0,0-3.339.817Zm1.269,4.7c0-1.657,1.659-1.867,2.778-1.867h1.082a3.923,3.923,0,0,1-.521,2.221,2.055,2.055,0,0,1-1.755.964c-.895,0-1.584-.4-1.584-1.319",
    transform: "translate(-138.512 -29.138)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1806",
    "data-name": "Rectangle 1806",
    width: 2.5,
    height: 15.72,
    transform: "translate(124.048 19.027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15153",
    "data-name": "Path 15153",
    d: "M291.227,52.71c0-1.509.633-3.436,2.238-3.436,1.622,0,2.071,1.99,2.071,3.436,0,1.487-.465,3.5-2.108,3.5-1.661,0-2.2-1.969-2.2-3.5m-2.519,5.428h2.425V56.819h.037a3.379,3.379,0,0,0,2.947,1.571c2.948,0,4.03-2.724,4.03-5.68,0-2.976-1.082-5.617-4.03-5.617a3.263,3.263,0,0,0-2.872,1.635h-.038v-6.31h-2.5v15.72",
    transform: "translate(-159.201 -23.391)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15154",
    "data-name": "Path 15154",
    d: "M314.6,56.068a4.69,4.69,0,0,1,2.965-1.173c1.474,0,2.164.587,2.164,2.326h-1.381a6.879,6.879,0,0,0-3.227.628,3.384,3.384,0,0,0,1.717,6.288,3.364,3.364,0,0,0,2.966-1.865h.037a14.8,14.8,0,0,0,.112,1.614h2.2c-.056-.839-.093-1.594-.112-2.411-.019-.8-.037-1.614-.037-2.7V57.389c0-3.186-1.213-4.548-4.141-4.548a7.81,7.81,0,0,0-3.339.817Zm1.269,4.7c0-1.657,1.659-1.867,2.778-1.867h1.082a3.923,3.923,0,0,1-.521,2.221,2.055,2.055,0,0,1-1.755.964c-.895,0-1.584-.4-1.584-1.319",
    transform: "translate(-172.859 -29.138)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15155",
    "data-name": "Path 15155",
    d: "M338.7,63.886h2.5V58.6c0-1.383.39-3.584,2.2-3.584,1.6,0,1.622,1.782,1.622,3.1v5.765h2.5V57.073c0-2.431-.989-4.232-3.264-4.232a3.466,3.466,0,0,0-3.152,1.717h-.038V53.091H338.7Z",
    transform: "translate(-186.769 -29.138)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15156",
    "data-name": "Path 15156",
    d: "M364.967,58.139h2.5V52.9h.038l3.21,5.239h3.171l-4.029-5.974,3.58-4.821h-2.947L367.5,51.662h-.038V42.418h-2.5Z",
    transform: "translate(-201.252 -23.391)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1807",
    "data-name": "Rectangle 1807",
    width: 32.745,
    height: 32.541,
    transform: "translate(0.531 1.796)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1808",
    "data-name": "Rectangle 1808",
    d: "M-1.183-1.183H32.623v33.6H-1.183ZM31.562-.122H-.122v31.48H31.562Z",
    transform: "translate(1.183 2.448)",
    fill: "#00914a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15157",
    "data-name": "Path 15157",
    d: "M27.651,22.1,37.678,8.225l-15.457.011L12.066,22.107,22.311,37,38,37.014Z",
    transform: "translate(-6.653 -4.536)",
    fill: "#00914a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoStgallerKantonalbank);
export default __webpack_public_path__ + "static/media/logo_stgaller_kantonalbank.7474ab96dbfe5a931b0776e9244b5c9c.svg";
export { ForwardRef as ReactComponent };